import { ContainerModule, interfaces } from 'inversify';
import { IIntegrationsService, IntegrationsService } from './integrations.service';
import { IIntegrationsStore, IntegrationsStore } from './integrations.store';

export const integrationModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IIntegrationsService.$).to(IntegrationsService).inSingletonScope();
  bind(IIntegrationsStore.$).to(IntegrationsStore).inSingletonScope();
});
